export default __webpack_public_path__ + "static/media/commercial-default.364493a8.jpg";